/**
 * NNH subscription buy box — tier card selection, Skio plan sync, OTP one-time add.
 */
(function (doc) {
  'use strict';

  function money(cents, symbol) {
    symbol = symbol || '$';
    return symbol + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function perDayLabel(cents, days, symbol) {
    symbol = symbol || '$';
    if (!cents || !days) return '--/day';
    var perDay = (cents / 100) / days;
    return symbol + perDay.toFixed(2) + '/day';
  }

  function cardLabel(card) {
    if (card.dataset.nnhBuyBoxLabel) return card.dataset.nnhBuyBoxLabel.trim();
    var labelEl = card.querySelector('[data-nnh-buy-box-label]');
    if (labelEl && labelEl.textContent.trim()) {
      return labelEl.textContent.trim();
    }
    var tier = (card.dataset.tier || card.dataset.nnhBuyBoxCard || '').toLowerCase();
    if (tier === 'monthly') return '1 Month Supply';
    if (tier === 'quarterly') return '3 Month Supply';
    return tier.charAt(0).toUpperCase() + tier.slice(1);
  }

  function getSelectionState(card) {
    if (!card) return null;
    var firstCents = Number(card.dataset.firstPriceCents || 0);
    var tier = (card.dataset.tier || card.dataset.nnhBuyBoxCard || '').toLowerCase();
    var perMonthCents = firstCents;
    if (tier === 'quarterly' && firstCents > 0) {
      perMonthCents = Math.round(firstCents / 3);
    }
    var bbRoot = card.closest('[data-nnh-buy-box]');
    var sym = (bbRoot && bbRoot.dataset.currencySymbol) || '$';
    return {
      label: cardLabel(card),
      price: firstCents > 0 ? money(firstCents, sym) : '',
      priceCents: firstCents,
      perMonth: perMonthCents > 0 ? money(perMonthCents, sym) : '',
      perMonthCents: perMonthCents,
      tier: tier,
      planId: card.dataset.sellingPlanId || ''
    };
  }

  function applySelectionState(root, state) {
    if (!root || !state) return;
    root.dataset.selectedLabel = state.label;
    root.dataset.selectedPrice = state.price;
    root.dataset.selectedPerMonth = state.perMonth;
    root.dataset.selectedTier = state.tier;
  }

  function dispatchBuyBoxChanged(state) {
    if (!state) return;
    doc.dispatchEvent(
      new CustomEvent('nnh:buybox:changed', {
        detail: state
      })
    );
  }

  function initBuyBox(root) {
    if (!root || root.dataset.nnhBuyBoxInit === 'true') return;
    root.dataset.nnhBuyBoxInit = 'true';

    var form = root.closest('[data-nnh-form]');
    if (!form) return;

    var variantInput = form.querySelector('[data-nnh-variant-id]');
    var planInput = form.querySelector('[data-nnh-selling-plan]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-nnh-buy-box-card]'));
    var atcBtn = root.querySelector('[data-nnh-buy-box-atc]');
    var atcLabel = atcBtn ? atcBtn.querySelector('[data-nnh-buy-box-atc-label]') : null;
    var otpBtn = root.querySelector('[data-nnh-buy-box-otp]');
    var quarterlyPlanId = root.dataset.quarterlyPlanId || '';
    var monthlyPlanId = root.dataset.monthlyPlanId || '';
    var currencySymbol = root.dataset.currencySymbol || '$';
    var selectedCard = cards.find(function (c) {
      return c.classList.contains('is-selected');
    }) || cards[0];
    var hero = root.closest('[data-pcos-hero]');
    var perDayEl = hero
      ? hero.querySelector('[data-hero-per-day-price]')
      : doc.querySelector('[data-hero-per-day-price]');

    function getOneMonthVariantId() {
      return root.dataset.oneMonthVariantId || '';
    }

    function selectCard(card, skipNotify) {
      if (!card) return;
      selectedCard = card;
      cards.forEach(function (c) {
        var isSelected = c === card;
        c.classList.toggle('is-selected', isSelected);
        c.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        var points = c.querySelector('[data-nnh-buy-box-points]');
        if (points) points.hidden = !isSelected;
      });

      var variantId = card.dataset.variantId || getOneMonthVariantId();
      if (variantInput) variantInput.value = variantId;
      if (planInput) planInput.value = card.dataset.sellingPlanId || '';
      if (atcBtn) atcBtn.dataset.variantId = variantId;

      var firstCents = Number(card.dataset.firstPriceCents || 0);
      if (atcLabel && firstCents > 0) {
        var ctaVerb = card.dataset.ctaVerb || atcLabel.dataset.ctaVerb || 'Add to Cart';
        atcLabel.textContent = ctaVerb + ' — ' + money(firstCents, currencySymbol);
      }

      var priceMonthlyEl = card.querySelector('.nnh-buy-box__price-monthly');
      if (priceMonthlyEl && priceMonthlyEl.dataset.staticPrice !== 'true' && firstCents > 0) {
        var tierName = (card.dataset.tier || '').toLowerCase();
        var textNode = priceMonthlyEl.childNodes[0];
        if (textNode && textNode.nodeType === 3) {
          if (tierName === 'quarterly') {
            textNode.data = money(Math.round(firstCents / 3), currencySymbol);
          } else if (tierName === 'monthly') {
            textNode.data = money(firstCents, currencySymbol);
          }
        }
      }

      if (perDayEl) {
        var days = Number(card.dataset.perDayDays || 0);
        perDayEl.textContent = perDayLabel(firstCents, days, currencySymbol);
      }

      var cardPerDayEl = card.querySelector('[data-nnh-buy-box-per-day]');
      if (cardPerDayEl && firstCents > 0) {
        var cardDays = Number(card.dataset.perDayDays || 0);
        cardPerDayEl.textContent = perDayLabel(firstCents, cardDays, currencySymbol);
      }

      var isAvailable = card.dataset.available !== 'false';
      if (atcBtn) atcBtn.disabled = !isAvailable;
      var stickyCta = doc.querySelector('[data-pcos-sticky-cta]');
      if (stickyCta) stickyCta.disabled = !isAvailable;

      var state = getSelectionState(card);
      applySelectionState(root, state);
      if (!skipNotify) dispatchBuyBoxChanged(state);
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectCard(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCard(card);
        }
      });
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.dataset.nnhOnetime === 'true') return;
        var subscribeFreq = root.querySelector('[data-frequency-input][value="subscribe"]');
        if (subscribeFreq) subscribeFreq.checked = true;
        if (selectedCard) selectCard(selectedCard);
      }, true);
    }

    if (otpBtn) {
      otpBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!getOneMonthVariantId()) return;

        var subscribeFreq = root.querySelector('[data-frequency-input][value="subscribe"]');
        if (subscribeFreq) subscribeFreq.checked = false;
        var otpVariantId = getOneMonthVariantId();
        if (variantInput) variantInput.value = otpVariantId;
        if (planInput) planInput.value = '';
        if (atcBtn) atcBtn.dataset.variantId = otpVariantId;

        var qtyInput = form.querySelector('[data-nnh-quantity]');
        var catcInput = form.querySelector('[data-nnh-compare-at]');
        var qty = qtyInput ? (+qtyInput.value || 1) : 1;
        var catc = catcInput ? (+catcInput.value || 0) : 0;
        var props = {};
        if (typeof window.getSelectedFlavor === 'function') {
          var flavor = window.getSelectedFlavor();
          if (flavor) props.Flavor = flavor;
        }

        var otpForm = otpBtn.closest('[data-nnh-form]');
        if (otpForm && otpForm.getAttribute('data-nnh-direct-checkout') === 'true') {
          window.location.href = '/cart/clear?return_to=' + encodeURIComponent(
            '/cart/add?items[0][id]=' + otpVariantId +
            '&items[0][quantity]=' + qty +
            '&return_to=/checkout'
          );
          return;
        }
        if (window.NNHCart && typeof window.NNHCart.addItem === 'function') {
          window.NNHCart.addItem({
            id: otpVariantId,
            selling_plan: '',
            quantity: qty,
            compare_at_cents: catc,
            properties: props,
            button: atcBtn
          });
          return;
        }

        if (atcBtn) {
          atcBtn.dataset.nnhOnetime = 'true';
          atcBtn.click();
          delete atcBtn.dataset.nnhOnetime;
        }
      });
    }

    selectCard(selectedCard, true);
    var initialState = getSelectionState(selectedCard);
    dispatchBuyBoxChanged(initialState);
    doc.dispatchEvent(new CustomEvent('nnh:buybox:ready', { detail: initialState }));

    if (root.dataset.buyBoxTier === 'otp_only') {
      var otpCents = Number(root.dataset.otpPerDayCents || 0);
      if (perDayEl && otpCents > 0) {
        perDayEl.textContent = perDayLabel(otpCents, 30);
      }
    }

    var vipLink = root.querySelector('[data-nnh-vip-bonuses-link]');
    var vipModal = root.querySelector('[data-nnh-vip-modal]');
    if (vipLink && vipModal) {
      var win = doc.defaultView;
      if (vipModal.parentNode !== doc.body) {
        doc.body.appendChild(vipModal);
      }

      var vipCloseEls = vipModal.querySelectorAll('[data-nnh-vip-modal-close]');
      var vipClosing = false;

      function openVipModal(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (vipClosing) return;
        vipModal.classList.add('is-open');
        vipModal.setAttribute('aria-hidden', 'false');
        doc.body.classList.add('nnh-vip-modal-open');
      }

      function closeVipModal(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (!vipModal.classList.contains('is-open')) return;
        vipClosing = true;
        vipModal.classList.remove('is-open');
        vipModal.setAttribute('aria-hidden', 'true');
        doc.body.classList.remove('nnh-vip-modal-open');
        if (win && win.location.hash === '#nnh-vip-bonuses') {
          try {
            win.history.replaceState(null, '', win.location.pathname + win.location.search);
          } catch (err) {}
        }
        setTimeout(function () {
          vipClosing = false;
        }, 300);
      }

      vipLink.addEventListener('click', openVipModal);
      Array.prototype.slice.call(vipCloseEls).forEach(function (el) {
        el.addEventListener('click', closeVipModal);
      });
      doc.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && vipModal.classList.contains('is-open')) {
          closeVipModal(e);
        }
      });
    }
  }

  function initAll() {
    Array.prototype.slice.call(doc.querySelectorAll('[data-nnh-buy-box]')).forEach(initBuyBox);
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', initAll);
  } else {
    setTimeout(initAll, 0);
  }
})(document);
